import { Home } from 'lucide-react';
import { FC } from 'react';
import { CardState } from '../../types/cardState';
import { LightContractCard } from '../cards/LightContractCard';
import { useBorrowerRealEstate } from './useBorrowerRealEstate';

interface BorrowerRealEstateProps {
  isCardDisabled: boolean;
  status: CardState;
  borrowerProjectId?: string;
  onRefresh?: () => void;
}

export const BorrowerRealEstate: FC<BorrowerRealEstateProps> = ({
  isCardDisabled,
  status,
  borrowerProjectId,
  onRefresh
}) => {
  const { openRealEstatePanel } = useBorrowerRealEstate(onRefresh, { borrowerProjectId });

  return (
    <LightContractCard
      icon={
        <div className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center bg-primary/10">
          <Home className="w-5 h-5 text-primary" />
        </div>
      }
      title="CONTRACTUALIZATION.CARDS.REAL_ESTATE_TITLE"
      status={status}
      disabled={isCardDisabled}
      onClick={openRealEstatePanel}
    />
  );
};
